// removed by extract-text-webpack-plugin
module.exports = {"InfoList":"_3bYh4pcKxMidM9z9l7o4x5","title":"_3xS4ohooFaiMzMmbFCas2m","backgroundImage":"_37KYQS41FPM-9bTa3VbfHH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoList/InfoList.css
// module id = 494
// module chunks = 8